import styled from 'styled-components';

export const FileInput = styled.input.attrs({
  type: 'file',
})`
  display: none;
`;
